import { gql } from '@apollo/client';
import { TypedDocumentNode } from '@graphql-typed-document-node/core';

interface SearchAddressResponse {
  searchAddress: {
    address_id: string;
    address: string;
  }[];
}

interface SearchAddressVariables {
  query: string;
  count: number;
}

export const searchAddress = gql`
  query SearchAddress($query: String!, $count: Float!) {
    searchAddress(query: $query, count: $count) {
      address_id
      address
    }
  }
` as TypedDocumentNode<SearchAddressResponse, SearchAddressVariables>;
